/* eslint-disable */
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AlertAdapter } from 'pg-ui-library';
import { IBank } from 'src/interfaces'; // Make sure IBank is defined in your interfaces
import { useTranslation } from 'react-i18next';
import PersonalInfoService from 'src/services/personal-info.service';

export const useAddBank = (): UseMutationResult<any, Error, { bank: IBank; personnelNumber: string }, void> => {
  const { t } = useTranslation();

  return useMutation(
    (data: { bank: IBank; personnelNumber: string }) =>
      PersonalInfoService.postBankWithTicket(data.bank, data.personnelNumber),
    {
      onSuccess: () => {
        AlertAdapter('bankAddSuccess', 'success');
      },
      onError: (e: Error) => {
        AlertAdapter(e.message, 'error');
      },
    }
  );
};
